import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useOrganizerFollow(organizerId: string) {
  const { user } = useAuth();
  const [isFollowing, setIsFollowing] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchFollowStatus = async () => {
    if (!user) {
      setLoading(false);
      return;
    }
    try {
      const { data, error } = await supabase
        .from('organizer_followers')
        .select('id')
        .eq('user_id', user.id)
        .eq('organizer_id', organizerId)
        .maybeSingle();

      if (error) throw error;
      setIsFollowing(!!data);
    } catch (err) {
      console.error('Error fetching follow status:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFollowStatus();
  }, [user, organizerId]);

  const followOrganizer = async () => {
    if (!user) return;
    setIsFollowing(true);
    const { error } = await supabase
      .from('organizer_followers')
      .insert({ user_id: user.id, organizer_id: organizerId });
    if (error) {
      console.error('Error following organizer:', error);
      setIsFollowing(false);
    }
  };

  const unfollowOrganizer = async () => {
    if (!user) return;
    setIsFollowing(false);
    const { error } = await supabase
      .from('organizer_followers')
      .delete()
      .eq('user_id', user.id)
      .eq('organizer_id', organizerId);
    if (error) {
      console.error('Error unfollowing organizer:', error);
      setIsFollowing(true);
    }
  };

  return { isFollowing, loading, followOrganizer, unfollowOrganizer };
}
